<div class="loader-overlay" *ngIf="loading$ | async">
    <div class="loader"></div>
</div>
